<span class="dls-copy-code">
  <button 
   class="float-right"
    atlas-icon-button
    aria-label="Copy code"
    *ngIf='codeSnippet.length'
    (click)="copyCode($event)"
    atlasTooltip="Copy snippet">
    <mat-icon>content_copy</mat-icon>
  </button>
</span>
<code [innerHTML]="codeBlock" class="mat-body-1" *ngIf='codeSnippet.length'></code>
<code class="dls-trans-code mat-body-1">
  <ng-content #codeContent *ngIf='!codeSnippet.length'></ng-content>
</code>